import { Component, HostListener, OnInit } from '@angular/core';

import { OrganizationConfig } from '../../../../../models/organization-config';
import { ApiService } from '../../../../../services/api/api.service';
import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';
import { ComponentHasUnsavedChanges } from '../../../../../unsaved-changes-guard.service';


@Component({
  selector: 'app-climber-app-customization-settings',
  templateUrl: './climber-app-customization-settings.component.html',
  styleUrls: ['./climber-app-customization-settings.component.css']
})
export class ClimberAppCustomizationSettingsComponent implements OnInit, ComponentHasUnsavedChanges {

  public orgConfig: OrganizationConfig;
  public logoImageFileData: File = null;

  public loadingOrgConfig = true;
  public loadingSave = false;

  public successMessage = '';
  public errorMessage = '';
  public errors: any = {};
  public serverError: number = null;
  public unsavedChanges = false;

  public isHoveringPreviewButton = false;

  constructor(
    public apiService: ApiService,
    public orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.loadOrganizationConfig();
  }

  hasUnsavedChanges() {
    return this.unsavedChanges;
  }

  @HostListener('window:beforeunload')
  allowUnload() {
    return !this.hasUnsavedChanges();
  }

  /**
   * Load the organization config from the API.
   *
   * We do not use the local-stored copy, in order to avoid pop-in of changed
   * values.
   */
  public loadOrganizationConfig() {
    this.loadingOrgConfig = true;

    this.orgConfigService
      .loadOrganizationConfig()
      .then(() => {
        this.orgConfig = this.orgConfigService.getOrganizationConfig();
        const orgConfigServerError = this.orgConfigService.getOrganizationConfigServerError();
        if (orgConfigServerError) {
          this.serverError = orgConfigServerError;
        }
        this.loadingOrgConfig = false;
      });
  }

  public attachLogoImageFile(event) {
    this.logoImageFileData = event.target.files[0] as File;
    if (this.logoImageFileData.type.match(/image\/*/) == null) {
      this.errors.logo_image = 'Invalid image file.';
      this.logoImageFileData = null;
      return;
    }
    if (this.logoImageFileData.size > 2097152){
      this.errors.logo_image = 'Image file is larger than 2 MB.';
      this.logoImageFileData = null;
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.logoImageFileData);
    reader.onload = () => {
      this.orgConfig.logo_image = reader.result as string;
    };
    this.unsavedChanges = true;
  }

  public save() {
    this.loadingSave = true;

    this.errorMessage = '';
    this.errors = {};
    this.successMessage = '';

    this.orgConfigService
      .updateClimberAppCustomization(
        this.orgConfig,
        this.logoImageFileData
      )
      .then(updatedOrgConf => {
        this.unsavedChanges = false;
        this.orgConfig = updatedOrgConf;
        this.successMessage = 'Settings updated successfully.';
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors shown and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to modify these settings.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingSave = false;
      });
  }

}
